import * as Yup from "yup";

import { variables } from "../../Variables";

const { required, quantityMin } = variables;

export const createBatchSchema = Yup.object({
  reference_number: Yup.string().required(required),
  lot_number: Yup.string().required(required),
  main_type: Yup.string().required(required),
  sub_type: Yup.string().required(required),
  size: Yup.string().required(required),
  previous_temperature: Yup.string().required(required),
  expiry_date: Yup.string().required(required),
  manufacture_date: Yup.string().required(required),
});

export const transferBatchSchema = Yup.object({
  main_type: Yup.string().required(required),
  parent_batch_id: Yup.string().required(required),
  batch_type: Yup.string().required(required),
  reference_number: Yup.string().required(required),
  new_reference_number: Yup.string().required(required),
  // previous_temperature: Yup.string().required(required),
  expiry_date: Yup.string().required(required),
  dispatch_date: Yup.string().required(required),
  size: Yup.string().required(required),
  quantity: Yup.number()
    .required(required)
    .min(1, quantityMin)
    .test("quantity", ``, function (value) {
      if (value == null) return true;
      if (this.parent.size < value) {
        return this.createError({
          path: this.path,
          message: `Quantity must be less than or equal to ${this.parent.size}`,
        });
      }
      return true;
    }),
  receiver_id: Yup.string().required(required),
});

export const transferBatchSchema1 = Yup.object({
  main_type: Yup.string().required(required),
  sub_type: Yup.string().required(required),
  batch_type: Yup.string().required(required),
  parent_batch_id: Yup.string().required(required),
  reference_number: Yup.string().required(required),

  // expiry_date: Yup.string().required(required),
  dispatch_date: Yup.string().required(required),
  // size: Yup.string().required(required),
  quantity: Yup.number()
    .required(required)
    .min(1, quantityMin)
    .test("quantity", ``, function (value) {
      if (value == null) return true;
      if (this.parent.size < value) {
        return this.createError({
          path: this.path,
          message: `Quantity must be less than or equal to ${this.parent.size}`,
        });
      }
      return true;
    }),
  receiver_id: Yup.string().required(required),
});

export const retireBatchSchema = Yup.object({
  batch_id: Yup.string().required(required),
  retire_type: Yup.string().required(required),
  quantity: Yup.number()
    .required(required)
    .min(1, quantityMin)
    .test("quantity", ``, function (value) {
      if (value == null) return true;
      if (this.parent.available_quantity < value) {
        return this.createError({
          path: this.path,
          message: `Quantity must be less than or equal to ${this.parent.available_quantity}`,
        });
      }
      return true;
    }),
});

export const receiveInventorySchema = Yup.object({
  quantity_received: Yup.string().required(required),
  quantity_damaged: Yup.string().required(required),
  previous_temperature: Yup.string().required(required),
  expiry_date: Yup.string().required(required),
});
